module.exports = __webpack_public_path__ + "media/retinol-small.5fc9055c.mp4";